import { render, staticRenderFns } from "./LiveVikiDeposits.container.vue?vue&type=template&id=7a6a1a54&scoped=true&"
import script from "./LiveVikiDeposits.container.vue?vue&type=script&lang=js&"
export * from "./LiveVikiDeposits.container.vue?vue&type=script&lang=js&"
import style0 from "./LiveVikiDeposits.container.vue?vue&type=style&index=0&id=7a6a1a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6a1a54",
  null
  
)

export default component.exports